import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

// Components
import CheckoutSideTotals from "./CheckoutSideTotals";
import CheckoutSideProducts from "./CheckoutSideProducts";
import Loader from "../../utils/Loader";

class CheckoutSideSummary extends Component {
	render() {
		const { country = "" } = this.props.shipping;

		return (
			<div className="checkout-section section--small">
				{this.props.cartLoading ?
				<div className="pt2 pb2">
					<Loader />
				</div> :
				<Fragment>
					<div className="hbs-cart-order-total">
						<CheckoutSideTotals />
					</div>

					<div className="section">
						<div className="section-heading section--side-heading">
							<span className="txt">Cart Summary</span>
							<span className="content">{country}</span>
						</div>
						<div className="section-content hbs-cart-summary">
							<CheckoutSideProducts />
						</div>
					</div>
				</Fragment>
				}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		items: state.cart.items,
		shipping: state.cart.shipping ? state.cart.shipping : {},
		cartLoading: state.cart.loading
	};
};

export default connect(mapStateToProps, {})(CheckoutSideSummary);



// WEBPACK FOOTER //
// ./src/components/checkout/side-summary/CheckoutSideSummary.js